
import api from '@/api'

// 登录（密码）
export function login(data) {
    return api({
        url: '/api/auth/login.api',
        method: 'post',
        data
    })
}

// 登录（密码）
export function getPermission(data) {
    return api({
        url: '/api/auth/menu_info.api',
        method: 'post',
        data
    })
}

